var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-light"},[_c('div',{staticClass:"container space-2"},[_c('UpdateAvatarForm'),_c('hr',{staticClass:"my-7"}),_c('FavoriteTagsForm'),_c('hr',{staticClass:"my-7"}),_c('PersonalInfoForm')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }